import { useContext } from 'react';
import { Switch } from '../../../Common/ui-components';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import Button from '../../../Common/ui-components/Button';
import { useTranslation } from 'react-i18next';
import { useRaceSimUnityWebGLPopUp } from './UnityWebGLPopUp';

const RaceSimulatorBottom = ({ boxShadow = false, fixed = false, isOpenAdjust, resetRunners, onViewResult }) => {
    const { t } = useTranslation();
    const globalContext = useContext(GlobalContext);
    const {
        resetRsImportanceValue,
        rsShowType,
        rsShowPage,
        rsIsWatchVideo,
        setRsIsWatchVideo,
        ViewResultButtomDisabled = false
    } = globalContext;

    const handleReset = () => {
        if (isOpenAdjust) {
            resetRunners(true);
        } else {
            resetRsImportanceValue.current();
        }
    };

    return (
        rsShowPage != 'RS_RESULT' && (
            <div
                className={`race-simulator-bottom ${boxShadow ? 'race-simulator-bottom-boxShadow' : ''}  ${
                    fixed ? 'race-simulator-bottom-fixed' : ''
                }`}
            >
                <div className="watch-simulator">
                    <span className="watch-simulator-text">{t('RS_WATCH_VIDEO')}</span>
                    <div>
                        <Switch
                            checked={rsIsWatchVideo}
                            onChange={(v) => setRsIsWatchVideo(v)}
                            checkedChildren={t('LB_RS_ON')}
                            unCheckedChildren={t('LB_RS_OFF')}
                        />
                    </div>
                </div>
                <div className={`rs-mobiles-bottom-buttons ${rsShowType}`}>
                    {rsShowType === 'Advanced' && (
                        <Button variant="outlined" className={`Reset-buttom`} onClick={handleReset}>
                            {t('RS_RESET')}
                        </Button>
                    )}
                    <Button
                        disabled={ViewResultButtomDisabled}
                        variant="filled"
                        className={`View-Result-buttom`}
                        onClick={() => onViewResult?.()}
                    >
                        {t('RS_VIEW_RESULT')}
                    </Button>
                </div>
            </div>
        )
    );
};

export default RaceSimulatorBottom;
